import { render } from "./UpdateInfoStep2.vue?vue&type=template&id=22e9e156&ts=true"
import script from "./UpdateInfoStep2.vue?vue&type=script&lang=ts"
export * from "./UpdateInfoStep2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__